//hooks
import { UserConsumer } from "../../hooks/context/UserContext";

//component
import TimeAndHourBooking from "../TimeAndHourBooking"

//utilis
import { formatDateTimeUTC } from "../../utils/formatDateTime"

//translation
import { useTranslation } from "react-i18next";
import i18n from "../../translate/i18n";

//mui icon
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';

//type
import { transactionsListType } from "../../api/profile/type/transactionsListType";

type TranscationCardProps = {
  element: transactionsListType;
};

const TranscationCard = ({element}:TranscationCardProps) => {
    const {t} = useTranslation()
    let {theme} = UserConsumer()
    return (
        <div className="bg-[#c1c3c74a] shadow-xl rounded-lg p-3 flex flex-col gap-2">
                <div className='flex max-md:flex-col justify-between gap-3'>
                    <TimeAndHourBooking
                    title={t("checkin_date")}
                    value={`${formatDateTimeUTC(element.booking.check_in_at|| "").date}`}
                    icon={<CalendarTodayIcon/>}
                    type = {""}
                    /> 
                    <TimeAndHourBooking
                    title={t("checkout_date")}
                    value={`${formatDateTimeUTC(element.booking.check_out_at || "").date}`}
                    icon={<CalendarMonthIcon/>}
                    type = {""}
                    />  
                </div>
                <div className='flex max-md:flex-col justify-between gap-3'>
                    <TimeAndHourBooking
                    title={t("checkin_time")}
                    value={`${formatDateTimeUTC(element.booking?.check_in_at || "").time}`}
                    icon={<QueryBuilderIcon/>}
                    type = {""}
                    />  
                    <TimeAndHourBooking
                    title={t("checkout_time")}
                    value={`${formatDateTimeUTC(element.booking?.check_out_at || "").time}`}
                    icon={<WatchLaterIcon/>}
                    type = {""}
                    />  
                </div>
                <div className="flex justify-center items-center sm:gap-10 gap-5 mt-3">
                    <div className='flex items-center'>
                        <LocationOnOutlinedIcon className={theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}/>
                        <span className="ml-1">{element?.booking?.location_in}</span>
                    </div>
                    <div>
                        {i18n.language === "en" ? <KeyboardTabIcon/> : <KeyboardTabIcon className='rotate-180'/>}
                    </div>
                    <div className='flex items-center'>
                        <EmojiFlagsIcon className='!text-red-500'/>
                        <span className="ml-1">{element?.booking?.location_out}</span>
                    </div>
                </div>
                <div className="w-full h-[2px] bg-gray-500"></div>
                <div className="flex justify-between items-center">
                    <h2>{t("total_amount")}</h2>
                    <p className="text-[13px] max-sm:text-[11px] font-[700]">{element?.total_amount}</p>
                </div>
                <div className="flex justify-between items-center">
                    <h2>{t("status")}</h2>
                    <p className="text-[13px] max-sm:text-[11px] font-[700]">{t(`${element?.status}`)}</p>
                </div>
        </div>
    )
}

export default TranscationCard